import Fingerprint2 from '@fingerprintjs/fingerprintjs'
import { MSG_NETWORK_ERR, LS_KEYS } from './constants'
import { addRegVisitLog } from '@/api/sign'
import { getCookie, generateRandomStr } from '@/util/util'

/**
 * 获取设备id
 */
const mixinGetDeviceId = {
  methods: {
    async getDeviceId () {
      // 设备id
      let deviceId = localStorage.getItem(LS_KEYS.deviceId)

      if (deviceId) {
        // 本地有缓存，优先缓存
        return deviceId
      }

      try {
        const components = await Fingerprint2.getPromise()
        const values = components.map(function (component) {
          return component.value
        })

        // 加随机字符串、时间戳
        values.push(generateRandomStr(18), Date.now() + '')

        deviceId = Fingerprint2.x64hash128(values.join(''), 31)
        // 缓存到本地
        localStorage.setItem(LS_KEYS.deviceId, deviceId)
      } catch (error) {
        console.log(error)
      }

      return deviceId
    }
  }
}

/**
 * 注册、登录页面访问记录
 */
const mixinAddRegVisitLog = {
  mixins: [mixinGetDeviceId],
  data () {
    return {
      fromPath: '', // 前一个地址
      shortUrl: '' // 当前页面路径
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      function cmpFullPath (info) {
        let path = info.path
        let query = info.query
        let needQueryKey = [
          'channelNo',
          'channelCode',
          'activityGroupId',
          'groupId'
        ]
        let qeuryStr = ''

        needQueryKey.forEach(key => {
          let val = query[key]

          if (val) {
            qeuryStr += `&${key}=${val}`
          }
        })

        return `${path}${qeuryStr ? `?${qeuryStr.substring(1)}` : ''}`
      }

      vm.fromPath = cmpFullPath(from)
      vm.shortUrl = cmpFullPath(to)
    })
  },
  mounted () {
    this.addRegVisitLog({
      toUrl: this.fromPath, // 前向地址（注册前的上一个地址）
      shortUrl: this.shortUrl, // 页面地址（短链地址）
      channelCode: getCookie('channelCode') || '', // 访问渠道编码
      activityGroupId: null // 老带新拼团邀请拼团id
    })
  },
  methods: {
    async addRegVisitLog (param = {}) {
      let cacheDeviceId = localStorage.getItem(LS_KEYS.deviceId)
      // 设备id
      let deviceId = ''

      if (!cacheDeviceId) {
        // 缓存没有则需要等浏览器数据加载完
        await new Promise(resolve => {
          setTimeout(() => {
            resolve()
          }, 350)
        })
        deviceId = await this.getDeviceId()
      } else {
        // 有缓存直接用缓存
        deviceId = cacheDeviceId
      }

      let baseParam = {}
      baseParam.deviceId = deviceId // 设备id
      baseParam.unitType = navigator ? navigator.userAgent || '' : '' // 设备型号
      baseParam.fromType = 'H5' // 访问来源（H5、小程序、商户端、合规帮手）

      let info = Object.assign(baseParam, param)
      console.log('发送访客记录', info)

      await addRegVisitLog(info).catch(e => null)
    }
  }
}

export {
  mixinGetDeviceId,
  mixinAddRegVisitLog
}



// WEBPACK FOOTER //
// ./src/util/mixins.js